import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

interface SelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'lib-form-select',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './form-select.html',
})
export class FormSelect {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) control!: FormControl<unknown>;
  @Input({ required: true }) options!: SelectOption[];

  isFieldInvalid(): boolean {
    return !!(
      this.control &&
      this.control.invalid &&
      (this.control.dirty || this.control.touched)
    );
  }
}
